'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _SettingsStore = require('./settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2016 OpenMarket Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var request = require('browser-request');

var SdkConfig = require('./SdkConfig');
var MatrixClientPeg = require('./MatrixClientPeg');

var ScalarAuthClient = function () {
    function ScalarAuthClient() {
        (0, _classCallCheck3.default)(this, ScalarAuthClient);

        this.scalarToken = null;
    }

    (0, _createClass3.default)(ScalarAuthClient, [{
        key: 'connect',
        value: function connect() {
            var _this = this;

            return this.getScalarToken().then(function (tok) {
                _this.scalarToken = tok;
            });
        }
    }, {
        key: 'hasCredentials',
        value: function hasCredentials() {
            return this.scalarToken != null; // undef or null
        }

        // Returns a scalar_token string

    }, {
        key: 'getScalarToken',
        value: function getScalarToken() {
            var _this2 = this;

            var token = window.localStorage.getItem("mx_scalar_token");

            if (!token) {
                return this.registerForToken();
            } else {
                return this.validateToken(token).then(function (userId) {
                    var me = MatrixClientPeg.get().getUserId();
                    if (userId !== me) {
                        throw new Error("Scalar token is owned by someone else: " + me);
                    }
                    return token;
                }).catch(function (err) {
                    console.error(err);

                    // Something went wrong - try to get a new token.
                    console.warn("Registering for new scalar token");
                    return _this2.registerForToken();
                });
            }
        }
    }, {
        key: 'validateToken',
        value: function validateToken(token) {
            var url = SdkConfig.get().integrations_rest_url + "/account";

            return new _bluebird2.default(function (resolve, reject) {
                request({
                    method: "GET",
                    uri: url,
                    qs: { scalar_token: token },
                    json: true
                }, function (err, response, body) {
                    if (err) {
                        reject(err);
                    } else if (response.statusCode / 100 !== 2) {
                        reject({ statusCode: response.statusCode });
                    } else if (!body || !body.user_id) {
                        reject(new Error("Missing user_id in response"));
                    } else {
                        resolve(body.user_id);
                    }
                });
            });
        }
    }, {
        key: 'registerForToken',
        value: function registerForToken() {
            var _this3 = this;

            // Get openid bearer token from the HS as the first part of our dance
            return MatrixClientPeg.get().getOpenIdToken().then(function (token_object) {
                // Now we can send that to scalar and exchange it for a scalar token
                return _this3.exchangeForScalarToken(token_object);
            }).then(function (token_object) {
                window.localStorage.setItem("mx_scalar_token", token_object);
                return token_object;
            });
        }
    }, {
        key: 'exchangeForScalarToken',
        value: function exchangeForScalarToken(openid_token_object) {
            var scalar_rest_url = SdkConfig.get().integrations_rest_url;

            return new _bluebird2.default(function (resolve, reject) {
                request({
                    method: 'POST',
                    uri: scalar_rest_url + '/register',
                    body: openid_token_object,
                    json: true
                }, function (err, response, body) {
                    if (err) {
                        reject(err);
                    } else if (response.statusCode / 100 !== 2) {
                        reject({ statusCode: response.statusCode });
                    } else if (!body || !body.scalar_token) {
                        reject(new Error("Missing scalar_token in response"));
                    } else {
                        resolve(body.scalar_token);
                    }
                });
            });
        }
    }, {
        key: 'getScalarPageTitle',
        value: function getScalarPageTitle(url) {
            var scalarPageLookupUrl = SdkConfig.get().integrations_rest_url + '/widgets/title_lookup';
            scalarPageLookupUrl = this.getStarterLink(scalarPageLookupUrl);
            scalarPageLookupUrl += '&curl=' + encodeURIComponent(url);

            return new _bluebird2.default(function (resolve, reject) {
                request({
                    method: 'GET',
                    uri: scalarPageLookupUrl,
                    json: true
                }, function (err, response, body) {
                    if (err) {
                        reject(err);
                    } else if (response.statusCode / 100 !== 2) {
                        reject({ statusCode: response.statusCode });
                    } else if (!body) {
                        reject(new Error("Missing page title in response"));
                    } else {
                        var title = "";
                        if (body.page_title_cache_item && body.page_title_cache_item.cached_title) {
                            title = body.page_title_cache_item.cached_title;
                        }
                        resolve(title);
                    }
                });
            });
        }

        /**
         * Mark all assets associated with the specified widget as "disabled" in the
         * integration manager database.
         * This can be useful to temporarily prevent purchased assets from being displayed.
         * @param  {string} widgetType [description]
         * @param  {string} widgetId   [description]
         * @return {Promise}           Resolves on completion
         */

    }, {
        key: 'disableWidgetAssets',
        value: function disableWidgetAssets(widgetType, widgetId) {
            var url = SdkConfig.get().integrations_rest_url + '/widgets/set_assets_state';
            url = this.getStarterLink(url);
            return new _bluebird2.default(function (resolve, reject) {
                request({
                    method: 'GET',
                    uri: url,
                    json: true,
                    qs: {
                        'widget_type': widgetType,
                        'widget_id': widgetId,
                        'state': 'disable'
                    }
                }, function (err, response, body) {
                    if (err) {
                        reject(err);
                    } else if (response.statusCode / 100 !== 2) {
                        reject({ statusCode: response.statusCode });
                    } else if (!body) {
                        reject(new Error("Failed to set widget assets state"));
                    } else {
                        resolve();
                    }
                });
            });
        }
    }, {
        key: 'getScalarInterfaceUrlForRoom',
        value: function getScalarInterfaceUrlForRoom(room, screen, id) {
            var roomId = room.roomId;
            var roomName = room.name;
            var url = SdkConfig.get().integrations_ui_url;
            url += "?scalar_token=" + encodeURIComponent(this.scalarToken);
            url += "&room_id=" + encodeURIComponent(roomId);
            url += "&room_name=" + encodeURIComponent(roomName);
            url += "&theme=" + encodeURIComponent(_SettingsStore2.default.getValue("theme"));
            if (id) {
                url += '&integ_id=' + encodeURIComponent(id);
            }
            if (screen) {
                url += '&screen=' + encodeURIComponent(screen);
            }
            return url;
        }
    }, {
        key: 'getStarterLink',
        value: function getStarterLink(starterLinkUrl) {
            return starterLinkUrl + "?scalar_token=" + encodeURIComponent(this.scalarToken);
        }
    }]);
    return ScalarAuthClient;
}();

module.exports = ScalarAuthClient;
//# sourceMappingURL=ScalarAuthClient.js.map